import React from 'react'
import type { FC } from 'react';
import type { SectionItem, TableGroup } from '../reservations.types';

const StatsBar: FC<{ sections: SectionItem[]; groups: TableGroup[] }> = ({ sections, groups }) => {
  const allTables = sections.flatMap(s => s.tables);
  const totalTables = allTables.length;
  const activeTables = allTables.filter(t => t.isActive).length;
  const activeSections = sections.filter(s => s.isActive).length;
  const mergedGroups = groups.filter(g => g.isActive).length;

  const stats = [
    { label: "Total Sections", value: sections.length, sub: `${activeSections} active` },
    { label: "Total Tables",   value: totalTables,      sub: `${activeTables} active` },
    { label: "Total Capacity", value: allTables.filter(t => t.isActive).reduce((a, t) => a + t.capacity, 0), sub: "seats" },
    { label: "Active Merges",  value: mergedGroups,     sub: "table groups" },
  ];

  return (
    <div className="grid grid-cols-2 md:grid-cols-4 gap-4 mb-6">
      {stats.map((s, i) => (
        <div key={i} className="bg-white rounded-2xl px-5 py-4 border border-gray-100 shadow-sm">
          <p className="m-0 text-2xl font-extrabold text-stone-900 leading-none">{s.value}</p>
          <p className="m-0 mt-1 text-xs font-semibold text-stone-600">{s.label}</p>
          <p className="m-0 mt-0.5 text-[11px] text-gray-400">{s.sub}</p>
        </div>
      ))}
    </div>
  );
};

export default StatsBar